/** SIP-Trunk eines Dataspace: wie Telefonate zu seinen Prozessen kommen und sie verlassen. */

export default {
	telephony: {
		title: "Telefonie",
		hint: "Telefonate für die Prozesse dieses Dataspace. Eine Telefonanlage schickt Anrufe per SIP an diesen Server, oder dieser Dataspace meldet sich dort als Nebenstelle an. Was ein Anruf bewirkt, bestimmt der Prozess.",
		retry: "Erneut versuchen",
		saved: "Telefonie-Einstellungen gespeichert.",
		removed: "Telefonie-Einstellungen entfernt.",
		remove: "Telefonie-Einstellungen entfernen",
		removeConfirm: "Telefonie-Einstellungen dieses Dataspace entfernen?",
		removeNote:
			"Die Einstellungen und beide gespeicherten Passwörter werden gelöscht; der Server nimmt keine Anrufe mehr für diesen Dataspace an und zieht seine Anmeldung zurück. Das lässt sich nicht rückgängig machen.",
		savedElsewhere: {
			title: "Zwischenzeitlich anderswo gespeichert",
			body: "Jemand hat diese Einstellungen gespeichert, während Sie sie bearbeitet haben. Ihre Änderungen bleiben erhalten; Speichern ersetzt das Gespeicherte durch Ihre Fassung.",
			load: "Gespeicherte Fassung laden",
		},
		list: {
			add: "{value} hinzufügen",
		},
		password: {
			set: "gesetzt",
			change: "Ändern",
			remove: "Löschen",
			willRemove: "wird beim Speichern gelöscht",
			new: "{label} (neu)",
			keep: "Aktuelles Passwort behalten",
		},
		status: {
			title: "Status",
			refresh: "Aktualisieren",
			readAt: "Stand: {time}",
			endpointOffTitle: "Dieser Server nimmt keine SIP-Anrufe an",
			endpointOff:
				"SIP ist auf diesem Server ausgeschaltet (SIP_ENABLED). Ein hier gespeicherter Trunk bewirkt nichts, bis ein Administrator SIP einschaltet.",
			errorTitle:
				"Der gespeicherte Trunk ist nicht nutzbar. Anrufe werden abgewiesen, bis er neu gespeichert wird.",
			endpoint: "SIP-Endpunkt",
			on: "An",
			off: "Aus",
			sipUri: "SIP-Adresse",
			sipUriHint:
				"Tragen Sie diese Adresse in der Telefonanlage als Trunk ein, an den Anrufe geschickt werden.",
			copy: "Kopieren",
			copied: "Kopiert",
			activeCalls: "Laufende Anrufe",
			routers: "Prozesse, die Anrufe annehmen",
			routersHint: "Laufende Prozesse dieses Dataspace, die auf Anrufe warten.",
			noRouters:
				"Kein laufender Prozess dieses Dataspace wartet auf Anrufe; jeder Anruf geht daher an das, was unter „Nicht angenommene Anrufe“ steht.",
			registration: {
				title: "Anmeldung",
				registered: "Angemeldet",
				registering: "Anmeldung läuft…",
				failed: "Fehlgeschlagen",
				until: "bis {time}",
				none: "Keine Anmeldung",
				again: "Erneut anmelden",
				againStarted: "Anmeldung mit den gespeicherten Zugangsdaten wird wiederholt.",
			},
		},
		callsIn: {
			title: "Eingehende Anrufe",
			hint: "Die Telefonanlage schickt Anrufe an die SIP-Adresse dieses Servers. Ein Anruf wird am Digest-Login unten erkannt, oder an der Adresse, von der er kommt, zusammen mit der gewählten Nummer.",
			enabled: "Anrufe annehmen und tätigen",
			enabledHelp:
				"Ausgeschaltet behält der Trunk seine Einstellungen, nimmt aber keine Anrufe an und meldet sich nirgends an.",
			username: "Digest-Benutzername",
			usernameHelp:
				"Womit sich die Telefonanlage anmeldet. Ein Benutzername gehört zu genau einem Dataspace dieses Servers.",
			usernameTaken: "Ein anderer Dataspace verwendet diesen Benutzernamen bereits.",
			password: "Digest-Passwort",
			passwordHelp: "Wird verschlüsselt gespeichert und nie wieder angezeigt.",
			sources: "Erlaubte Quelladressen",
			sourcesPlaceholder: "Adresse oder Netz hinzufügen…",
			sourcesHint: "Eine IP-Adresse oder ein Netz wie 192.0.2.0/24",
			sourcesHelp:
				"Anrufe von diesen Adressen werden anhand der gewählten Nummer diesem Dataspace zugeordnet.",
			sourcesInvalid: "{value} ist weder eine IP-Adresse noch ein Netz wie 192.0.2.0/24.",
			numbers: "Nummern",
			numbersPlaceholder: "Nummer oder Nebenstelle hinzufügen…",
			numbersHint: "Eine Nummer, eine Nebenstelle oder ein Präfix mit * am Ende",
			numbersHelp:
				"Die Nummern, die dieser Dataspace annimmt. Ein * am Ende passt auf alle Nummern, die so beginnen, etwa +4930*. Leer: jede Nummer.",
			numbersInvalid: "{value} ist keine zulässige Nummer.",
			numbersWildcard: "Ein * ist nur am Ende einer Nummer ein Platzhalter.",
		},
		registration: {
			title: "Anmeldung",
			hint: "Diesen Dataspace bei der Telefonanlage als Nebenstelle anmelden und Anrufe dort entgegennehmen, statt oder zusätzlich zu eingehenden Anrufen.",
			registrar: "Registrar",
			registrarPlaceholder: "pbx.example.com:5060",
			registrarHelp: "Adresse der Telefonanlage, Host oder Host:Port. Leer: keine Anmeldung.",
			extension: "Nebenstelle",
			extensionHelp: "Die Nebenstelle, als die angemeldet wird.",
			authUsername: "Authentifizierungs-Benutzername",
			authUsernameHelp:
				"Nur, wenn die Authentifizierungs-ID der Telefonanlage nicht die Nebenstelle ist.",
			password: "Anmeldepasswort",
			expires: "Erneuerungsintervall (Sekunden)",
			expiresHelp: "Wie lange eine Anmeldung gilt, bevor sie erneuert wird.",
		},
		callsOut: {
			title: "Ausgehende Anrufe",
			hint: "Wie Anrufe aus diesem Dataspace und Weiterleitungen die Telefonanlage erreichen.",
			proxy: "Ausgehender Proxy",
			proxyHelp:
				"Host oder Host:Port, über den Anrufe gehen. Leer: der Registrar. Ohne beides kann ein Prozess keine Anrufe tätigen.",
			callerId: "Anruferkennung",
			callerIdHelp:
				"Nummer oder Name, die bei einem Anruf von hier angezeigt werden, sofern der Prozess keine nennt. Leer: die Nebenstelle.",
		},
		alternis: {
			title: "Alternis",
			hint: "Wie ein Anruf zu Alternis kommt, für Transkription und Vorschläge.",
			integration: "Anbindung",
			comsSystem: "Über die Telefonanlage",
			comsSystemHelp:
				"Die Telefonanlage gibt jeden Anruf wie üblich an Alternis. Notitia leitet nichts weiter.",
			notitia: "Über Notitia",
			notitiaHelp:
				"Die Telefonanlage weiß nichts von Alternis. Der Prozess legt die Sitzung an, und Notitia leitet das Audio des Anrufs weiter.",
			rtpAddress: "Alternis-RTP-Adresse",
			rtpAddressPlaceholder: "alternis.example.com:35000",
			rtpAddressHelp:
				"Host:Port des RTP-Sockets von Alternis, an den Notitia das Audio eines Anrufs weiterleitet. Leer: der Alternis-Host, den der Prozess verwendet, Port 35000.",
		},
		unclaimed: {
			title: "Nicht angenommene Anrufe",
			hint: "Ein Anruf muss von einem Prozess dieses Dataspace angenommen werden. Das hier gilt, wenn das nicht rechtzeitig geschieht oder der Prozess, der ihn angenommen hat, nicht mehr da ist.",
			timeout: "Warten auf einen Prozess (Sekunden)",
			timeoutHelp: "Wie lange ein Anruf darauf wartet, angenommen zu werden.",
			then: "Danach",
			reject: "Anruf abweisen",
			rejectHelp:
				"Die Telefonanlage erhält den Status unten. Ein bereits angenommener Anruf wird beendet.",
			redirect: "An eine Nummer weiterleiten",
			redirectHelp:
				"Der Anruf geht stattdessen an eine andere Nummer. Ein bereits angenommener Anruf wird dorthin vermittelt.",
			status: "Abweisungsstatus",
			statusHelp:
				"Der SIP-Status, den die Telefonanlage erhält. 480 heißt „vorübergehend nicht erreichbar“, 486 „besetzt“.",
			target: "Zielnummer der Weiterleitung",
			targetHelp:
				"Eine E.164-Nummer wie +4930123456 oder eine andere Nummer oder Nebenstelle, die die Telefonanlage versteht.",
		},
		advanced: {
			title: "Erweitert",
			maxCalls: "Gleichzeitige Anrufe",
			maxCallsHelp: "Wie viele Anrufe dieses Dataspace gleichzeitig laufen dürfen.",
			advertised: "Bekanntgegebene Adresse",
			advertisedHelp:
				"Host oder Host:Port, den dieser Server der Telefonanlage für Antworten und Audio nennt, wenn sie ihn unter einer anderen als seiner eigenen Adresse erreicht.",
		},
		problems: {
			range: "Zwischen {min} und {max}.",
			host: "Kein Host. Einen Namen oder eine Adresse mit optionalem :Port angeben — ohne Schema wie sip:, ohne Pfad, ohne Leerzeichen.",
			port: "Es fehlt ein Port. Angabe als Host:Port.",
			tooMany: "Höchstens {max} Einträge.",
			text: "Höchstens {max} Zeichen, ohne Zeilenumbrüche oder andere Steuerzeichen.",
			inboundPassword: "Ein Digest-Benutzername braucht ein Passwort.",
			registrationUsername: "Ein Registrar braucht die Nebenstelle, als die angemeldet wird.",
			fallbackTarget: "Eine Weiterleitung braucht eine Nummer, an die der Anruf geht.",
		},
	},
};
